import type { DetailTab } from "@/components/detail-page/types";
import { TabsTrigger } from "@/components/ui/tabs";
import type { ReactNode } from "react";

export function SectionTabTriggers({ sections }: { sections: DetailTab[] }): ReactNode {
  return sections.map((section) => (
    <TabsTrigger key={section.id} value={section.id}>
      {section.icon && <section.icon />}
      {section.label}
    </TabsTrigger>
  ));
}
